import axios from "axios";
import axiosInstance from "./axiosInstance";
import { primeImageUrl } from "./imageCache";

export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

// A bare instance: presigned S3 PUTs must not carry our Authorization header.
// S3 rejects a request that presents both a signed query string and an
// Authorization header ("Only one auth mechanism allowed"). Created once at
// module load and stripped explicitly, so it cannot inherit an Authorization
// default from anything that mutates the shared axios singleton.
const uploadAxios = axios.create();
delete uploadAxios.defaults.headers.common.Authorization;

// PUTs a file to a presigned S3 URL. Resolves to whether the upload succeeded,
// matching how the callers report per-file upload state.
export async function uploadImageToServer(file, url) {
    try {
        await uploadAxios.put(url, file, {
            headers: { "Content-Type": file.type },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        });
        return true;
    } catch (error) {
        console.error("Upload failed:", error.message);
        return false;
    }
}

// Uploads a verification ID image and returns its S3 key plus a local preview
// URL. The preview seeds the image cache, so the freshly uploaded file renders
// without a second round trip for a presigned download URL.
export async function uploadGuestImage(file) {
    const { data } = await axiosInstance.get(
        `/api/v1/images/upload-presigned-url?file_name=${encodeURIComponent(file.name)}`,
    );

    const { key, url } = data;

    await uploadAxios.put(url, file, {
        headers: { "Content-Type": file.type },
    });

    const previewUrl = URL.createObjectURL(file);
    primeImageUrl(key, previewUrl);

    return { key, previewUrl };
}
